<div class="bg-[#f7f7f7]">
  <div class="h-full padding2 space-y-16 md:space-y-24 px-6 py-12">
    <div
      class="flex w-full flex-col justify-between space-y-16 md:flex-row md:gap-28 md:space-y-0"
    >
      <div class="flex md:w-1/2 flex-col space-y-6">
        <a href="/">
          <img
            src="https://voyagex.ai/wp-content/uploads/VoyageXai_icon-150x150.png"
            alt="VoyageX icon"
            height="48"
            width="48"
            class="h-12 w-12 aspect-auto"
            loading="lazy"
          />
        </a>
        <a
          href="/"
          class="text-sm font-medium text-gray-600 uppercase hover:underline"
          >VOYAGEX JOBS</a
        >
      </div>

      <div class="flex md:w-1/2 space-x-0 justify-between">
        <div class="hidden md:flex"></div>

        <div class="flex flex-col gap-3">
          <label class="text-base font-semibold md:text-base"> Company </label>
          <ul class="flex flex-col gap-2 text-sm font-normal text-gray-800">
            <li class="text-sm underline-offset-1 hover:underline md:text-sm">
              <a href="https://voyagex.ai/about/"> About VoyageX </a>
            </li>
            <li class="text-sm underline-offset-1 hover:underline md:text-sm">
              <a href="/companies">Companies</a>
            </li>
            <li class="text-sm underline-offset-1 hover:underline md:text-sm">
              <a href="https://voyagex.ai/contact-us/"> Contact Us </a>
            </li>
          </ul>
        </div>

        <div class="flex flex-col gap-3">
          <label class="text-base font-semibold">Social</label>
          <ul id="company" class="flex space-x-4">
            <li class="hover:scale-105 transition-all">
              <a
                aria-label="X"
                href="https://x.com/voyagexai/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="x.svg" alt="X_icon" width="24" height="24" />
              </a>
            </li>
            <li class="hover:scale-105 transition-all">
              <a
                aria-label="Linkedin"
                href="https://www.linkedin.com/company/voyagex-ai/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="linkedIn.svg"
                  alt="Linkedin_icon"
                  width="24"
                  height="24"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="flex flex-col md:flex-row justify-between md:items-center space-y-3 md:space-y-0"
    >
      <ul
        class="md:flex items-center md:items-start space-x-0 md:space-x-5 md:gap-0 text-sm text-gray-500 grid grid-cols-1 gap-3"
      >
        <li>
          <a href="https://voyagex.ai/privacy-policy/" class="hover:underline"
            >Privacy Policy</a
          >
        </li>
        <li>
          <a href="https://voyagex.ai/terms-of-service/" class="hover:underline"
            >Terms of Service</a
          >
        </li>
        <li>
          <a
            href="https://voyagex.ai/legal-notice-imprint/"
            class="hover:underline"
            >Legal Notice</a
          >
        </li>
        <li>
          <a href="https://voyagex.ai/cookie-policy-eu/" class="hover:underline"
            >Cookie Policy (EU)</a
          >
        </li>
      </ul>
      <p class="text-sm text-gray-500">© {{ currentYear }} VoyageX AI</p>
    </div>
  </div>
</div>
